// src/config/routes/public.routes.ts
import { BarChartBig, FunctionSquare, Hexagon, Monitor, Network, ScrollText, User } from 'lucide-react';
import { lazy } from 'react';
import { RouteConfig } from 'src/types/route-config.types';

export const protectedRoutes: RouteConfig[] = [
    // --- Onboarding Section ---

    {
        name: "Dashboard",
        path: "/dashboard",
        component: lazy(() => import('src/pages/dashboard/DashboardPage')),
        showInSideNav: true,
        sideNavGroupName: "",
        access: ["consumer"],
        breadcrumbPath: ["dashboard"],
        icon: <User className='h-2 w-2' />,
        isDefaultFor: ["consumer"],
        order: 3,
    },
    // start : try for commit
    // {
    //     name: "GEC Certificatedd",
    //     path: "/gec-certificate/back-certificate",
    //     component: lazy(() => import('src/components/gec_Certificate/certificate/back-certificate/BackCertificateVerification')),
    //     showInSideNav: true,
    //     sideNavGroupName: "GEC Certificate",
    //     access: ["consumer"],
    //     breadcrumbPath: ["GEC Certificate", "Certificate"],
    //     icon: <User className='h-2 w-2' />,
    //     order: 2.1,
    //     meta: {
    //         title: "Green Energy Tokens balance",
    //         description: ""
    //     }
    // },

    //  {
    //     name: "concent",
    //     path: "/concent",
    //     component: lazy(() => import('src/components/opt-green-energy-modal/opt-energy-form/OptEnergyConcentModel')),
    //     showInSideNav: true,
    //     sideNavGroupName: "",
    //     access: ["consumer"],
    //     breadcrumbPath: ["consent"],
    //     icon: <User className='h-2 w-2' />,
    //     isDefaultFor: ["consumer"],
    //     order: 3,
    //     meta: {
    //         title: "Consumer Dashboard",
    //         description: "Overview of your green energy consumption and activities."
    //     }
    // },
    {
        name: "Energy Monitoring",
        path: "/energy-monitoring",
        component: lazy(() => import('src/pages/energy-monitoring/EnergyMonitoringDashboardPage')),
        showInSideNav: true,
        sideNavGroupName: "",
        access: ["consumer"],
        breadcrumbPath: ["dashboard"],
        icon: <User className='h-2 w-2' />,
        isDefaultFor: ["consumer"],
        order: 3,
        meta: {
            title: "Energy Monitoring Dashboard",
            description: "Monitor your energy consumption with detailed analytics."
        }
    },
    {
        name: "Energy Impact",
        path: "/energy-impact",
        component: lazy(() => import('src/pages/consumer-impact/ConsumerImpactPage')),
        showInSideNav: true,
        sideNavGroupName: "",
        access: ["consumer"],
        breadcrumbPath: ["Energy Impact"],
        icon: <User className='h-2 w-2' />,
        isDefaultFor: ["consumer"],
        order: 1,

    },

    {
        name: "Consumer Energy Audit Reports",
        path: "/energy-audit/consumer-report",
        component: lazy(() => import('src/pages/audit-report/consumer/audit-report/ConsumerAuditReport')),
        showInSideNav: false,
        sideNavGroupName: "",
        access: ["consumer"],
        breadcrumbPath: ["energy-setting", "Energy Setting Form"],
        // icon: <FunctionSquare className='h-4 w-4' />,
        order: 8.2,
        meta: {
            title: "Consumer Energy Audit Report",
            description: "Consumption energy audit report with detailed analytics"
        }
    },

    {
        name: "Consumer Energy Audit Details",
        path: "/energy-audit/consumer-details",
        component: lazy(() => import('src/pages/audit-report/consumer/audit-details/ConsumerAuditDetails')),
        showInSideNav: false,
        sideNavGroupName: "",
        access: ["consumer", "administrator"],
        breadcrumbPath: ["dashboard"],
        icon: <User className='h-2 w-2' />,
        order: 3,
        meta: {
            title: "Consumer Energy Audit",
            description: "Monitor energy consumption with detailed analytics."
        }
    },

    {
        name: "Billing",
        path: "/billing",
        component: lazy(() => import('src/pages/billing/Index')),
        showInSideNav: true,
        sideNavGroupName: "",
        access: ["consumer"],
        breadcrumbPath: ["billing"],
        icon: <User className='h-2 w-2' />,
        isDefaultFor: ["consumer"],
        order: 4,
        meta: {
            title: "Green Energy Bill Summary",
            description: ""
        }
    },



    {
        name: "GEC Certificate",
        path: "/gec-certificate/certificate",
        component: lazy(() => import('src/pages/gec-certificate-report/GecCertificateReportPage')),
        showInSideNav: true,
        sideNavGroupName: "GEC Certificate",
        access: ["consumer"],
        breadcrumbPath: ["GEC Certificate", "Certificate"],
        icon: <User className='h-2 w-2' />,
        order: 2.1,
        meta: {
            title: "Green Energy Tokens balance",
            description: ""
        }
    },
    {
        name: "GEC Tracibility Report",
        path: "/gec-certificate/tracibility-report/:id",
        component: lazy(() => import('src/pages/gec-certificate-report/GCTracibilityReportPage')),
        showInSideNav: false,
        sideNavGroupName: "GEC Certificate",
        access: ["consumer"],
        breadcrumbPath: ["GEC Certificate", "Certificate"],
        icon: <User className='h-2 w-2' />,
        order: 2.1,
        meta: {
            title: "GEC Tracibility Report",
            description: ""
        }
    },
    // {
    //     name: "GEC",
    //     path: "/gec-certificate/gec",
    //     component: lazy(() => import('src/pages/gec-certificate/GecCertificate')),
    //     showInSideNav: true,
    //     sideNavGroupName: "GEC Certificate",
    //     access: ["consumer"],
    //     breadcrumbPath: ["GEC Certificate", "Certificate","GEC"],
    //     icon: <User className='h-2 w-2' />,
    //     order: 2.1,
    //     meta: {
    //         title: "",
    //         description: ""
    //     }
    // },


    {
        name: "Verify GEC",
        path: "/verifygec",
        component: lazy(() => import('src/pages/gec-verification/Index')),
        showInSideNav: true,
        sideNavGroupName: "",
        access: ["consumer"],
        breadcrumbPath: ["Verify GEC"],
        icon: <User className='h-2 w-2' />,
        order: 2.1,
        meta: {
            title: "Verify Certificate",
            description: "Verify Certificate details to link a consumer account"
        }
    },
    {
        name: "Verify GEC Success",
        path: "/gec-verification/success",
        component: lazy(() => import('src/components/gec-verify/gec-verification/VerificationSuccess')),
        showInSideNav: false,
        sideNavGroupName: "",
        access: ["consumer"],
        breadcrumbPath: ["Verify GEC", "Success"],
        icon: <User className='h-2 w-2' />,
        order: 2.1,
        meta: {
            title: "Verified Certificate",
            description: "Certificate verification result"
        }
    },
    {
        name: "Verify GEC Success",
        path: "/gec-verification/success",
        component: lazy(() => import('src/components/gec-verify/gec-verification/VerificationSuccess')),
        showInSideNav: false,
        sideNavGroupName: "",
        access: ["consumer"],
        breadcrumbPath: ["Verify GEC", "Success"],
        icon: <User className='h-2 w-2' />,
        order: 2.1,
        meta: {
            title: "Verified Certificate",
            description: ""
        }
    },
    {
        name: "Green Energy Configuration",
        path: "/custom",
        component: lazy(() => import('src/pages/custumize-plans/CustumPlans')),
        showInSideNav: false,
        sideNavGroupName: "Self-Service",
        access: ["consumer"],
        breadcrumbPath: ["Verify"],
        icon: <User className='h-2 w-2' />,
        order: 2.1,
        meta: {
            title: "Customize Your Plan",
            description: ""
        }
    },



   

    // {
    //     name: "Opt For Green Energy",
    //     path: "/opt-in",
    //     component: lazy(() => import('src/components/opt-green-energy-modal/OptGreenEnergyModelWeb')),
    //     showInSideNav: true,
    //     sideNavGroupName: "Self-Service",
    //     access: ["consumer"],
    //     breadcrumbPath: ["Self-Service", "Queries"],
    //     icon: <User className='h-2 w-2' />,
    //     isDefaultFor: ["consumer"],
    //     order: 1,
    //     meta: {
    //         title: "",
    //         description: ""
    //     }
    // },


    {
        name: "Help & Support",
        path: "/self-service/queries",
        component: lazy(() => import('src/pages/self-service/query-requests/QueryRequestsPage')),
        showInSideNav: true,
        sideNavGroupName: "Self-Service",
        access: ["consumer"],
        breadcrumbPath: ["Self-Service", "Queries"],
        icon: <User className='h-2 w-2' />,
        isDefaultFor: ["consumer"],
        order: 1,
        meta: {
            title: "Help & Support",
            description: "Get assistance with your green energy queries."
        }
    },
    {
        name: "Energy Requisition",
        path: "/energy-requisition",
        component: lazy(() => import('src/pages/energy-requisition/EnergyRequisitionPage')),
        showInSideNav: true,
        sideNavGroupName: "Self-Service",
        access: ["consumer"],
        breadcrumbPath: ["Energy Requisition"],
        icon: <User className='h-2 w-2' />,
        isDefaultFor: ["consumer"],
        order: 1,
    },


    {
        name: "Energy Requisition Details",
        path: "/energy-requisition/details",
        component: lazy(() => import('src/pages/energy-requisition/contract-details/EnergyRequisitionDetailsPage')),
        showInSideNav: false,
        sideNavGroupName: "",
        access: ["consumer"],
        breadcrumbPath: ["Energy Requisition"],
        icon: <User className='h-2 w-2' />,
        isDefaultFor: ["consumer"],
        order: 1,
    },


    {
        name: "Reports",
        path: "/gec-certificate/reports",
        component: lazy(() => import('src/pages/DocumentReport/DocumentReportPage')),
        showInSideNav: true,
        sideNavGroupName: "Reports",
        access: ["consumer"],
        breadcrumbPath: ["Reports", "Reports"],
        icon: <User className='h-2 w-2' />,
        order: 3.1,
        meta: {
            title: "Reports",
            description: "To register an eligible consumer for energy usage."
        }
    },
     {
        name: "ESG GreenEnergy Certificate",
        path: "/esg-green-energy-certificate",
        component: lazy(() => import('src/pages/Reports/ESGGreenEnergyCertificate/ESGGreenEnergyCertificate')),
        showInSideNav: true,
        sideNavGroupName: "Reports",
        access: ["consumer"],
        breadcrumbPath: ["TermsAndConditions"],
        icon: <User className='h-2 w-2' />,
        order: 2.1,
        meta: {
            title: "",
            description: ""
        }
    },


    {
        name: "RE-100 Report",
        path: "/re-report",
        component: lazy(() => import('src/pages/Reports/RE100Report/RE100ReportPage')),
        showInSideNav: true,
        sideNavGroupName: "Reports",
        access: ["consumer"],
        breadcrumbPath: ["TermsAndConditions"],
        icon: <User className='h-2 w-2' />,
        order: 2.1,
        meta: {
            title: "",
            description: ""
        }
    },

    {
        name: "Science-Based Tariff Report",
        path: "/science-based-tarrif-report",
        component: lazy(() => import('src/pages/Reports/ScienceBasedTarrifReport/ScienceBasedTarrifReportPage')),
        showInSideNav: true,
        sideNavGroupName: "Reports",
        access: ["consumer"],
        breadcrumbPath: ["TermsAndConditions"],
        icon: <User className='h-2 w-2' />,
        order: 2.1,
        meta: {
            title: "",
            description: ""
        }
    },

    {
        name: "SEBI-Business",
        path: "/sebi-business/report",
        component: lazy(() => import('src/pages/SEBI-Business/SEBI-Business-Page')),
        showInSideNav: true,
        sideNavGroupName: "Reports",
        access: ["consumer"],
        breadcrumbPath: ["Opt-In"],
        icon: <User className='h-2 w-2' />,
        isDefaultFor: ["consumer"],
        order: 1,
    },

    {
        name: "BEE-RCO-Form",
        path: "/bee-rco-report/form",
        component: lazy(() => import('src/pages/bee/rco-report/RcoReportFormMainPage')),
        showInSideNav: true,
        sideNavGroupName: "Reports",
        access: ["consumer"],
        breadcrumbPath: ["Opt-In"],
        icon: <User className='h-2 w-2' />,
        isDefaultFor: ["consumer"],
        order: 1,
    },
    {
        name: "BEE-RCO-Report",
        path: "/bee-rco-report/report",
        component: lazy(() => import('src/pages/bee/rco-report/RcoReportMainPage')),
        showInSideNav: true,
        sideNavGroupName: "Reports",
        access: ["consumer"],
        breadcrumbPath: ["Opt-In"],
        icon: <User className='h-2 w-2' />,
        isDefaultFor: ["consumer"],
        order: 1,
    },

    // {
    //     name: "BEE-RCO-Table-Report",
    //     path: "/bee-rco-report-table/report",
    //     component: lazy(() => import('src/components/bee/rco-report/components/RCOReportTable/RCOReportPage')),
    //     showInSideNav: true,
    //     sideNavGroupName: "Reports",
    //     access: ["consumer"],
    //     breadcrumbPath: ["Opt-In"],
    //     icon: <User className='h-2 w-2' />,
    //     isDefaultFor: ["consumer"],
    //     order: 1,
    // },

    // {
    //     name: "Configuration",
    //     path: "/configuration",
    //     component: lazy(() => import('src/pages/configuration/configurationFormPage')),
    //     showInSideNav: true,
    //     // sideNavGroupName: "Self - Service tool",
    //     access: ["admin"],
    //     breadcrumbPath: ["configuration", "configuration"],
    //     icon: <User className='h-2 w-2' />,
    //     order: 3.1,
    //     meta: {
    //         title: "configuration",
    //         description: "To register an eligible consumer for energy usage."
    //     }
    // },

    {
        name: "Consumption Overview",
        path: "/consumptionoverview",
        component: lazy(() => import('src/pages/ConsumptionOverview/Index')),
        showInSideNav: true,
        sideNavGroupName: "Consumption Overview",
        access: ["*"],
        breadcrumbPath: ["Consumption Overview"],
        icon: <User className='h-2 w-2' />,
        isDefaultFor: ["consumer"],
        order: 3,
        meta: {
            title: "Consumption Overview",
            description: "provides users with real-time insights and detailed historical data."
        }
    },

    {
        name: "Opt Energy Concent",
        path: "/opt-energy-concent",
        component: lazy(() => import('src/pages/opt-energy-concent/OptEnergyConcentPage')),
        showInSideNav: false,
        sideNavGroupName: "",
        access: ["consumer"],
        breadcrumbPath: ["Opt Energy Concent"],
        icon: <User className='h-2 w-2' />,
        isDefaultFor: ["consumer"],
        order: 1,

    },
      
    {
        name: "OPT-IN",
        path: "/opt-in-form",
        component: lazy(() => import('src/components/energy-requisition/opt-in/OptInPage')),
        showInSideNav: false,
        sideNavGroupName: "",
        access: ["consumer"],
        breadcrumbPath: ["Opt-In"],
        icon: <User className='h-2 w-2' />,
        isDefaultFor: ["consumer"],
        order: 1,
    },
    // {
    //     name: "BEE-Report",
    //     path: "/bee-report/report",
    //     component: lazy(() => import('src/pages/bee/bee-report/BeeReportPage')),
    //     showInSideNav: true,
    //     sideNavGroupName: "BEE-Report",
    //     access: ["consumer"],
    //     breadcrumbPath: ["Opt-In"],
    //     icon: <User className='h-2 w-2' />,
    //     isDefaultFor: ["consumer"],
    //     order: 1,
    // },

    

    //  {
    //     name: "BEE-RCO-Table-Report",
    //     path: "/bee-rco-report-table/report",
    //     component: lazy(() => import('src/components/bee/rco-report/components/RCOReportTable/RCOReportPage')),
    //     showInSideNav: true,
    //     sideNavGroupName: "BEE-Report",
    //     access: ["consumer"],
    //     breadcrumbPath: ["Opt-In"],
    //     icon: <User className='h-2 w-2' />,
    //     isDefaultFor: ["consumer"],
    //     order: 1,
    // },
     {
        name: "SEBI-Business",
        path: "/sebi-business/report",
        component: lazy(() => import('src/pages/SEBI-Business/SEBI-Business-Page')),
        showInSideNav: true,
        sideNavGroupName: "SEBI-Report",
        access: ["consumer"],
        breadcrumbPath: ["Opt-In"],
        icon: <User className='h-2 w-2' />,
        isDefaultFor: ["consumer"],
        order: 1,
    },
];